import forEach from 'lodash/forEach';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';

let mmHeight;
let mmWidth;

class ConfiguratorHeaderCtrl {
    constructor(config, dataService, jsonService, $cookies, $scope, apiService, $locale, windowDimensionsService, handlesService,
        cartBarsService, $location, $anchorScroll, $rootScope, glassRulesService) {
        this.jsonService = jsonService;
        this.dataService = dataService;
        this.$locale = $locale;
        this.windowDimensionsService = windowDimensionsService;
        this.handlesService = handlesService;
        this.cartBarsService = cartBarsService;
        this.glassRulesService = glassRulesService;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.unit = [];
        this.heights = [];
        this.widths = [];
        this.bottomPanels = [];
        this.$cookies = $cookies;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.apiService = apiService;
        this.attributes = this.dataService.getAttributes();
        this.maxProductWidth = this.attributes.maxWidth;
        this.minProductWidth = this.attributes.minWidth;
        this.margin = this.attributes.dimensionMargin;
        this.mmHeight = this.windowDimensionsService.dimensionsData.height;
        this.mmWidth = this.windowDimensionsService.dimensionsData.width;
        this.currentMinHeight = 0;
        this.currentMaxHeight = 0;
        this.showDimensionInfo = false;
        this.showCasementInfo = false;
        this.hingeSideOption = null;
        this.availableSizes = this.attributes.availableSizes;
        this.goToConfiguratorBtnText = 'BTN_GO_TO_CONFIGURATOR_DEFAULT';
        this.configuratorBoxes = config.boxes;
        this.showAssociatedProductSwitch = false;

        this.$locale.NUMBER_FORMATS.GROUP_SEP = ' ';
        this.$locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
        this.customDimensions = [];
        this.customWindow = true;
        this.priceCalculate = this.dataService.priceReload;
        this.shapeType = null;
        this.shapes = config.shapes;
        this.activeShapes = [];
        this.activeShape = null;

        this.defaultDrawingSide = this.dataService.data.data[0].attributes['defaultInsideView'] ? 'inner' : 'outer';
        this.shapeError = false;
        this.widthError = false;
        this.heightError = false;

        this.$rootScope.$on('showCasementModalEvent', () => this.openCasementModal());
        this.$rootScope.$on('colorChangeEvent', () => this.calculateDimensions());
        this.$rootScope.$on('colorChangeEvent', () => this.dimensionsInit());
        this.$rootScope.$on('savedToCartEvent', () => this.showMiniCartPreview());
    }

    onInit() {
        this.unitsInit();
        this.productType = this.dataService.getProductType();
        this.selectedUnit = find(this.unit, ['id', this.dataService.getSelectedOptionId('unit') || '2']);

        if (!this.dataService.isBlindProduct()) { //@todo: blinds
            this.shape = this.jsonService.getJson().shape;
            this.customDimensionsInit();
        }
        this.dimensionsInit();
        this.setAssociatedSize();
        this.selectInitialWidth();
        this.selectInitialHeight();
        this.updateDimensionsSelect();
        this.selectInitialBottomPanel();
        this.editableDimensions = this.selectedUnit.type === 'custom';
        if (this.editableDimensions) {
            this.setInitialDimensions();
        } else {
            this.onSelectChange();
        }
        this.getHingeSideOption();
        this.mainProductImage = `/files/configurations/${this.productInfo.configurationImg}`;
        this.initTriangleSide();
        this.goToConfiguratorBtn();
        if (this.dataService.isBalconyDoorOrEntranceDoor()) {
            this.handlesService.onInit();
            this.getHandleOptions();
        }
        if (this.dataService.isEntranceDoor()) {
            if (this.attributes.windowFunctionId !== 1) {
                this.getHandleColors();
            }
            this.setDefaultDoorColor();
        }
        if (this.productType === 'roof_window') {
            this.selectedFlashingOption = this.dataService.getSelectedOption('flashing', 'flashing');
            this.flashingOptions = this.dataService.getAttributeOptions('flashing');
        }
        if (this.shape && this.shape.shape === 'polygon') {
            this.activeShapes = this.shapes.polygon;
            this.activeShape = find(this.activeShapes, shape => shape.default);
        }
        this.maxProductWidth = this.attributes.maxWidth;
        this.minProductWidth = this.attributes.minWidth;
        this.dataService.divideSashesByMullionsAndDividers();
        this.productsFromGroup = this.productInfo.productsFromGroup;
        this.setDefaultColorBasedOnAssociation();
    }

    goToConfiguratorBtn() {
        switch (this.productInfo.productCategory) {
            case 'fonster':
                this.goToConfiguratorBtnText = 'BTN_GO_TO_CONFIGURATOR_WINDOW';
                break;
            case 'fonsterdorr':
                this.goToConfiguratorBtnText = 'BTN_GO_TO_CONFIGURATOR_WINDOW_DOOR';
                break;
            case 'vikdorr':
                this.goToConfiguratorBtnText = 'BTN_GO_TO_CONFIGURATOR_FOLDING_DOOR';
                break;
            case 'skjutdorr':
                this.goToConfiguratorBtnText = 'BTN_GO_TO_CONFIGURATOR_SLIDING_DOOR';
                break;
            case 'ytterdorrar':
                this.goToConfiguratorBtnText = 'BTN_GO_TO_CONFIGURATOR_DOOR';
                break;
            case 'takfonster':
                this.goToConfiguratorBtnText = 'BTN_GO_TO_CONFIGURATOR_ROOF_WINDOW';
                break;
        }
    }

    setShape(shape) {
        const width = this.dataService.getAttributes().width;
        const height = this.dataService.getAttributes().height;

        if (this.shape && this.shape.shape === 'polygon') {
            switch (shape.id) {
                case 'SLT':
                    this.shape.s1 = width;
                    this.shape.s2 = 0;
                    this.shape.s3 = 0;
                    this.shape.h1 = height;
                    this.shape.h2 = 0;
                    this.shape.h3 = Math.ceil(height * 0.5);
                    break;

                case 'SRT':
                    this.shape.s1 = 0;
                    this.shape.s2 = 0;
                    this.shape.s3 = width;
                    this.shape.h1 = height;
                    this.shape.h2 = Math.ceil(height * 0.5);
                    this.shape.h3 = 0;
                    break;

                case 'SLS':
                    this.shape.s1 = Math.ceil(width * 0.3);
                    this.shape.s2 = width - this.shape.s1;
                    this.shape.s3 = 0;
                    this.shape.h1 = height;
                    this.shape.h2 = 0;
                    this.shape.h3 = 0;
                    break;

                case 'SRS':
                    this.shape.s1 = 0;
                    this.shape.s3 = Math.ceil(width * 0.7);
                    this.shape.s2 = width - this.shape.s3;
                    this.shape.h1 = height;
                    this.shape.h2 = 0;
                    this.shape.h3 = 0;
                    break;

                case 'SLC':
                    this.shape.s1 = Math.ceil(width * 0.7);
                    this.shape.s2 = width - this.shape.s1;
                    this.shape.s3 = 0;
                    this.shape.h1 = height;
                    this.shape.h2 = 0;
                    this.shape.h3 = Math.ceil(height * 0.5);
                    break;

                case 'SRC':
                    this.shape.s1 = 0;
                    this.shape.s3 = Math.ceil(width * 0.7);
                    this.shape.s2 = width - this.shape.s3;
                    this.shape.h1 = height;
                    this.shape.h2 = Math.ceil(height * 0.5);
                    this.shape.h3 = 0;
                    break;

                case 'DLT':
                    this.shape.s1 = Math.ceil(width * 0.5);
                    this.shape.s2 = 0;
                    this.shape.s3 = Math.ceil(width * 0.5);
                    this.shape.h1 = height;
                    this.shape.h2 = Math.ceil(height * 0.5);
                    this.shape.h3 = Math.ceil(height * 0.5);
                    break;

                case 'DLS':
                    this.shape.s1 = Math.ceil(width * 0.7);
                    this.shape.s2 = Math.ceil(width - width * 0.7);
                    this.shape.s3 = Math.ceil(width * 0.7);
                    this.shape.h1 = height;
                    this.shape.h2 = 0;
                    this.shape.h3 = 0;
                    break;

                case 'DLC':
                    this.shape.s1 = Math.ceil(width * 0.3);
                    this.shape.s2 = Math.ceil(width - width * 0.6);
                    this.shape.s3 = Math.ceil(width * 0.3);
                    this.shape.h1 = height;
                    this.shape.h2 = Math.ceil(height * 0.5);
                    this.shape.h3 = Math.ceil(height * 0.5);
                    break;
            }
            this.activeShape = shape;
            this.jsonService.getJson().shape = this.shape;
            this.updateWidthHeight();
            this.$rootScope.$emit('dimensionsChangeEvent');
        }
    }

    /**
     * Set default door color from cookie
     */
    setDefaultDoorColor() {
        let configId = this.dataService.apiService.configurationId;
        if (!this.$cookies.get(`default_config_color_${configId}`)) {
            return false;
        }

        // Get cookie
        let colorId = this.$cookies.get(`default_config_color_${configId}`);

        if (angular.isUndefined(colorId) || colorId === null || colorId === '') {
            return false;
        }

        // Remove cookie since we don't need it anymore
        this.$cookies.remove(`default_config_color_${configId}`, {
            path: '/'
        });

        colorId = parseInt(colorId);
        const color = find(this.dataService.data.included.color, element => element.id === colorId);

        if (angular.isUndefined(color)) {
            return false;
        }

        // Update color, redraw visualization and recalculate price
        this.dataService.data.data[0].relationships.inner.data.id = color.id;
        this.dataService.data.data[0].relationships.outer.data.id = color.id;
        this.$rootScope.$emit('colorChangeEvent');

        return true;
    }

    setDefaultColorBasedOnAssociation() {
        let configId = this.dataService.apiService.configurationId;
        if (!localStorage.getItem('associatedConfigurationColor-' + configId)) {
            return false;
        }

        let colorId = localStorage.getItem('associatedConfigurationColor-' + configId);

        if (angular.isUndefined(colorId) || colorId === null || colorId === '') {
            return false;
        }

        localStorage.removeItem('associatedConfigurationColor-' + configId);

        colorId = parseInt(colorId);
        const color = find(this.dataService.data.included.color, element => element.id === colorId);

        if (angular.isUndefined(color)) {
            return false;
        }

        this.dataService.updateSelectedOptions('inner', [color.id], null, false);
        this.dataService.updateSelectedOptions('outer', [color.id], null, false);

        return true;
    }

    /**
     * Get list of handle options
     */
    getHandleOptions() {
        this.handlesService.setHandleOptions();
    }

    /**
     * Get list of colors for default handle and set them up in system
     */
    getHandleColors() {
        const selectedHandle = this.dataService.getSelectedOption('handleInside', 'handle');
        this.handlesService.setHandleColors(selectedHandle.relationships.colors);
        this.setHandleColor(selectedHandle.relationships.colors[0]);
    }

    setHandleColor(option) {
        if (angular.isUndefined(option)) {
            return false;
        }
        this.handlesService.setHandleColor(option.id);
        this.dataService.updateSelectedOptions(
            'handleColor',
            this.handlesService.selectedHandleColor,
            option.type,
            false,
        );
        return true;
    }

    getSeries() {
        return this.dataService.getAttributeOptions('series');
    }

    setInitialDimensions() {
        this.mmWidth = this.dataService.getAttributes().width;
        this.mmHeight = this.dataService.getAttributes().height;
        this.bottom = this.dataService.getAttributes().bottomPanel;
        this.oldDimensions = {
            width: this.mmWidth,
            height: this.mmHeight,
            bottom: this.bottom
        };
        this.calculateDimensions();
    }

    setAssociatedSize() {
        this.assocWidth = null;
        this.assocHeight = null;

        let configId = this.dataService.apiService.configurationId;
        if (!localStorage.getItem('associatedConfigurationSize-' + configId)) {
            return false;
        }

        let size = localStorage.getItem('associatedConfigurationSize-' + configId);

        if (angular.isUndefined(size) || size === null || size === '') {
            return false;
        }

        localStorage.removeItem('associatedConfigurationSize-' + configId);

        let dimensions = size.split('x');
        let width = parseInt(dimensions[0]);
        let height = parseInt(dimensions[1]);
        if (dimensions.length === 2) {
            if (width % 100 === 0 && height % 100 === 0) {
                this.assocWidth = width / 100;
                this.assocHeight = height / 100;
            } else {
                this.assocWidth = Math.round(width / 100);
                this.assocHeight = Math.round(height / 100);
            }
        }
    }

    setAssociatedSizeForLinkedProduct() {
        let configId = this.productInfo.associatedConfigurationId;
        if (configId && this.selectedUnit.type !== 'custom') {
            localStorage.setItem('associatedConfigurationSize-' + configId, this.selectedWidth * 100 + "x" + this.selectedHeight * 100);
        }

        if (configId && this.selectedUnit.type === 'custom') {
            localStorage.setItem('associatedConfigurationSize-' + configId, this.mmWidth + "x" + this.mmHeight);
        }
    }

    toggleSerie(id) {
        this.dataService.updateSelectedOptions('series', id, 'series', false);
    }

    getHingeSideOption() {
        const types = this.dataService.hingeSideTypes;
        if (this.dataService.getAttributes().windowFunctionId == 11) {
            return;
        }

        for (const type of types) {
            if (this.dataService.getOptionAvailableStatus(type)) {
                const attributeOptions = this.dataService.getAttributeOptions(type);
                this.hingeSideType = type;
                this.hingeSideOptions = attributeOptions;
                this.hingeSideSelectedId = this.hingeSideOptions.findIndex(elem => elem.attributes.name === 'Tilt båda sidor');
                if (!this.hingeSideSelectedId) {
                    if (this.defaultDrawingSide === 'inner') {
                        this.hingeSideSelectedId = this.hingeSideOptions.findIndex(elem => elem.attributes.name === 'Höger');
                    } else {
                        this.hingeSideSelectedId = this.hingeSideOptions.findIndex(elem => elem.attributes.name === 'Vänster');
                    }
                }

                if (this.hingeSideSelectedId > -1 && this.hingeSideType !== 'mirrorReflection') {
                    this.hingeSideSelected = this.hingeSideOptions[this.hingeSideSelectedId];
                    this.dataService.data.data[0].relationships[type].data.id = this.hingeSideSelected.id;
                } else {
                    this.hingeSideSelected = this.hingeSideOptions[0];
                    this.dataService.data.data[0].relationships[type].data.id = this.hingeSideSelected.id;
                }
                if (this.dataService.getAttributes().selectedHinge && this.hingeSideSelected.id !== this.dataService.getAttributes().selectedHinge) {
                    this.updateOption(this.hingeSideSelected, false);
                    this.hingeSideSelectedId = this.hingeSideOptions.findIndex(h => h.id === this.dataService.getAttributes().selectedHinge);
                    this.hingeSideSelected = this.hingeSideOptions[this.hingeSideSelectedId];
                    this.dataService.data.data[0].relationships[this.hingeSideSelected.type].data.id = this.hingeSideSelected.id;
                }
                this.updateOption(this.hingeSideSelected, true);
            }
        }
    }

    initTriangleSide() {
        if (this.shape && this.shape.s1 === 0) {
            this.triangleSide = 'right';
        } else {
            this.triangleSide = 'left';
        }
    }

    updateTriangleSide(side) {
        const currentLeftWidth = this.shape.s1;
        const currentRightWidth = this.shape.s3;

        this.shape.s1 = currentRightWidth;
        this.shape.s3 = currentLeftWidth;
        this.calculateDimensions();
    }

    updateOption(data, refreshPrice = true) {
        if (data.id == 3) {
            this.dataService.data.rules.handle_quantity = this.dataService.data.rules.original_handle_quantity * 2;
        } else {
            this.dataService.data.rules.handle_quantity = this.dataService.data.rules.original_handle_quantity;
        }
        this.dataService.updateSelectedOptions(data.type, data.id, data.type, false);
        if (refreshPrice) {
            this.$rootScope.$emit('colorChangeEvent');
        }
    }

    checkQuantity() {
        if (angular.isUndefined(this.dataService.quantity)) {
            this.dataService.quantity = 1;
        }
        this.dataService.setPrice();
    }

    updateFlashingOption(option) {
        this.dataService.updateSelectedOptions(option.type, option.id, option.type, false);
    }

    customDimensionsInit() {
        switch (this.shape.shape) {
            case 'triangle':
                this.customDimensions = ['h1', 's1', 's3'];
                this.shapeType = 'triangle';
                break;
            case 'arc':
                this.customDimensions = ['h1', 'h2', 's1'];
                break;
            case 'polygon':
                this.customDimensions = ['h1', 'h2', 'h3', 's1', 's2', 's3'];
                break;
            default:
                this.customWindow = false;
                this.windowDimensionsService.customWindow = false;
                break;
        }
    }

    /**
     * we have to remember that pricelist are in mm and user can choose sizes also in dm (from which we substract 20mm for montage)
     * so if minimal size in pricelist is for example 488mm user can't choose 5dm because 5dm = 500mm - 20mm = 480mm, so minimal size will be 6dm
     * the same with height - if max is 1580mm user can choose additional size - 16dm because 16dm = 1600mm - 20mm = 1580mm
     */
    dimensionsInit() {
        this.widths = Object.keys(this.availableSizes).map(el => parseInt(el)).sort((a, b) => (a - b));

        if (this.shape && this.shape.shape === 'circle') {
            this.widths = this.widths.filter(w => this.availableSizes[w].some(h => h === w));
        } else {
            this.heights = this.availableSizes[this.widths[0]].sort((a, b) => (a - b));
        }

        this.updateDimensionsSelectBasedOnRule();
    }

    updateDimensionsSelect() {
        if (this.shape && this.shape.shape !== 'circle') {
            if (!this.availableSizes[this.selectedWidth]) {
                let currentWidth = this.selectedWidth;
                this.selectedWidth = Object.keys(this.availableSizes).reduce(function(prev, curr) {
                    return (Math.abs(+curr - currentWidth) < Math.abs(+prev - currentWidth) ? +curr : +prev);
                });
            }
            this.heights = this.availableSizes[this.selectedWidth].sort((a, b) => (a - b));
            if (!this.heights.includes(this.selectedHeight)) {
                this.selectedHeight = this.heights[0];
            }
        }
        if (this.attributes.maxBottomPanel > 0) {
            this.bottomPanels = [];
            let minPanel = this.attributes.minBottomPanel;
            if (minPanel % 100 == 0 || minPanel % 100 > 80) {
                minPanel += 100;
            }
            for (let i = Math.ceil(minPanel / 100); i < this.selectedHeight; ++i) {
                this.bottomPanels.push(i);
            }
            this.bottomPanels.push('Helglas');
            if (!this.bottomPanels.includes(this.selectedBottomPanel)) {
                this.selectedBottomPanel = this.bottomPanels[this.bottomPanels.length - 1];
            }
        }

        this.updateDimensionsSelectBasedOnRule();
    }

    updateDimensionsSelectBasedOnRule() {
        const maxDimension = this.dataService.getMaxDimensionRules();
        if (maxDimension) {
            this.widths = this.widths.filter(width => width <= (maxDimension.width / 100));
            this.heights = this.heights.filter(height => height <= (maxDimension.height / 100));

            if (
                (this.selectedHeight && !this.heights.includes(this.selectedHeight)) ||
                (this.selectedWidth && !this.widths.includes(this.selectedWidth))
            ) {
                this.dataService.displayNoticeAboutDimensionColorRule();
            }

            if (!this.heights.includes(this.selectedHeight)) {
                this.selectedHeight = this.heights[0];
            }

            if (!this.widths.includes(this.selectedWidth)) {
                this.selectedWidth = this.widths[0];
            }
        }
    }

    getTotalPrice() {
        return this.dataService.getTotalPrice();
    }

    getTotalPriceForRegularCustomer() {
        return this.dataService.getTotalPriceForRegularCustomer();
    }

    getTotalNetPrice() {
        return this.dataService.getTotalNetPrice();
    }

    getPriceWithoutDiscount() {
        return this.dataService.getPriceWithoutDiscount();
    }

    getDiscountPercentageValue() {
        return this.dataService.getDiscountPercentageValue();
    }

    getDiscountValue() {
        return this.dataService.getDiscountValue();
    }

    getDimension(dimension, multiplier = this.selectedUnit.multiplier, montageSpace = this.selectedUnit.montageSpace) {
        if (dimension) {
            return Math.floor((dimension - montageSpace) * multiplier);
        }
        return null;
    }

    getBottomPannelHeight(bottom) {
        return bottom * this.selectedUnit.multiplier;
    }

    onChangeUnits(selectedUnitId) {
        this.selectedUnit = find(this.unit, ['id', selectedUnitId]);
        this.editableDimensions = this.selectedUnit.type === 'custom';
        if (this.editableDimensions) {
            this.mmWidth = Math.floor((this.selectedWidth - this.selectedUnit.montageSpace) * this.selectedUnit.multiplier);
            this.mmHeight = Math.floor((this.selectedHeight - this.selectedUnit.montageSpace) * this.selectedUnit.multiplier);
            let bottom = this.selectedBottomPanel;
            if (this.selectedBottomPanel === 'Helglas') {
                bottom = this.selectedHeight;
            }
            this.bottom = (bottom - this.selectedUnit.montageSpace) * this.selectedUnit.multiplier;
            this.oldDimensions = {
                height: this.mmHeight,
                width: this.mmWidth,
                bottom: this.bottom
            };
            this.setCurrentMinAndMaxHeight();
        } else {
            this.selectedWidth = Math.round(this.mmWidth / this.selectedUnit.multiplier);
            this.selectedHeight = Math.round(this.mmHeight / this.selectedUnit.multiplier);
            this.selectedBottomPanel = Math.round(this.bottom / this.selectedUnit.multiplier);
            this.calculateDimensions();
            this.updateDimensionsSelect();
        }
        this.dataService.updateSelectedOptions('unit', this.selectedUnit.id, 'unit', false);
    }

    onSelectChange() {
        this.editableDimensions = this.selectedUnit.type === 'custom';
        if (this.editableDimensions) {
            this.width = this.getDimension(this.selectedWidth);
            this.height = this.getDimension(this.selectedHeight);
            if (this.selectedBottomPanel) {
                let bottom = this.selectedBottomPanel;
                if (this.selectedBottomPanel === 'Helglas') {
                    bottom = this.selectedHeight;
                }
                this.bottom = this.getDimension(bottom);
            }
        }
        this.updateDimensionsSelect();
        this.calculateDimensions();
    }

    calculateDimensions() {
        if (this.dataService.isBlindProduct()) {
            this.verifyEditableDimensions();
            const dimensions = this.getEditableDimensionsObject();
            this.dataService.updateDataAttribute('height', dimensions.height);
            this.dataService.updateDataAttribute('width', dimensions.width);
            this.dataService.setPrice();
        } else {
            let dimensions;
            if (!this.editableDimensions) {
                this.verifyNonEditableDimensions();
                dimensions = this.getNonEditableDimensionsObject();
            } else {
                dimensions = this.getEditableDimensionsObject();
                this.verifyEditableDimensions();
            }
            if (this.shape && this.shape.shape === 'circle') {
                dimensions.height = dimensions.width;
            }
            this.oldDimensions = dimensions;
            this.shape = this.jsonService.updateShape(dimensions);
            this.jsonService.onDimensionsChange(dimensions);
            this.dataService.updateDataAttribute('height', dimensions.height);
            this.dataService.updateDataAttribute('width', dimensions.width);
            this.dataService.updateDataAttribute('bottomPanel', dimensions.bottom);
            this.dataService.validateAccessories();
            this.windowDimensionsService.noNewMullions = false;
            this.cartBarsService.refreshDimensions();
            this.dataService.validateBasementWindowRule();
            this.$rootScope.$emit('dimensionsChangeEvent');
            this.dataService.validateDimensionColorRule();
        }
    }

    selectInitialHeight() {
        this.selectedHeight = find(this.heights, el => el === this.assocHeight);

        if (angular.isUndefined(this.selectedHeight)) {
            this.selectedHeight = find(this.heights, el =>
                el === parseFloat((this.dataService.getAttributes().height + this.margin) / 100)
            );
            if (angular.isUndefined(this.selectedHeight) && !this.customWindow) {
                this.selectedHeight = this.heights[0];
            } else if (angular.isUndefined(this.selectedHeight)) {
                this.selectedHeight = (this.dataService.getAttributes().height + 20) / 100;
            }
        }
    }

    selectInitialBottomPanel() {
        this.selectedBottomPanel = find(this.bottomPanels, el =>
            el === parseFloat((this.dataService.getAttributes().bottomPanel + this.margin) / 100)
        );
        if (angular.isUndefined(this.selectedHeight) && !this.customWindow) {
            this.selectedBottomPanel = this.bottomPanels[this.bottomPanels.length - 1];
        } else if (angular.isUndefined(this.selectedHeight)) {
            this.selectedBottomPanel = (this.dataService.getAttributes().bottomPanel + 20) / 100;
        }
    }

    get mmHeight() {
        return mmHeight;
    }

    set mmHeight(value) {
        if (angular.isDefined(value) && !isNaN(value)) {
            mmHeight = parseInt(String(value).replace(/D/g, ''), 10);
            this.windowDimensionsService.dimensionsData.height = value;
        }
    }

    get mmWidth() {
        return mmWidth;
    }

    set mmWidth(value) {
        if (angular.isDefined(value) && !isNaN(value)) {
            mmWidth = parseInt(String(value).replace(/D/g, ''), 10);
            this.windowDimensionsService.dimensionsData.width = value;
        }
    }

    shapeValidate(oldValue) {
        const tmpShape = {};
        forEach(this.shape, (el, key) => {
            if (key !== 'shape' && key !== 'type') {
                tmpShape[key] = parseInt(String(el).replace(/D/g, ''), 10);
            } else {
                tmpShape[key] = el;
            }

            if (key !== 'shape' && key !== 'type' && isNaN(tmpShape[key])) {
                tmpShape[key] = oldValue;
            }
        });
        this.shape = cloneDeep(tmpShape);
    }

    selectInitialWidth() {
        this.selectedWidth = find(this.widths, el => el === this.assocWidth);

        if (angular.isUndefined(this.selectedWidth)) {
            this.selectedWidth = find(this.widths, el =>
                el === parseFloat((this.dataService.getAttributes().width + this.margin) / 100)
            );
            if (angular.isUndefined(this.selectedWidth)) {
                this.selectedWidth = this.widths[0];
            } else if (angular.isUndefined(this.selectedWidth)) {
                this.selectedWidth = this.dataService.getAttributes().width + 20 / 100;
            }
        }
    }

    updateDimensions(dimensionName, oldValue) {
        this.shapeValidate(oldValue);
        const initHeight = this.updateCustomDimensionHeight();
        let initWidth = this.shape.s1 + this.shape.s2 + this.shape.s3;

        if (initHeight > this.attributes.maxHeight && ['h1', 'h2', 'h3'].indexOf(dimensionName) > -1) {
            this.shape[dimensionName] = oldValue;
        } else if (initHeight < this.attributes.minHeight && ['h1', 'h2', 'h3'].indexOf(dimensionName) > -1) {
            this.shape[dimensionName] = oldValue;
        }

        if (initWidth > this.maxProductWidth && ['s1', 's2', 's3'].indexOf(dimensionName) > -1) {
            this.shape[dimensionName] = oldValue;
        } else if (initWidth < this.attributes.minWidth && ['s1', 's2', 's3'].indexOf(dimensionName) > -1) {
            this.shape[dimensionName] = oldValue;
        }

        this.jsonService.getJson().shape = this.shape;
        this.updateWidthHeight();
        this.$rootScope.$emit('dimensionsChangeEvent');
    }

    updateWidthHeight() {
        const dimensions = {};
        dimensions.height = this.updateCustomDimensionHeight();
        dimensions.width = this.shape.s1 + this.shape.s2 + this.shape.s3;
        this.mmWidth = dimensions.width;
        this.mmHeight = dimensions.height;
        this.jsonService.onDimensionsChange(dimensions);
        this.dataService.updateDataAttribute('height', dimensions.height);
        this.dataService.updateDataAttribute('width', dimensions.width);
        this.selectInitialHeight();
        this.selectInitialWidth();
        this.dataService.validateAccessories();
    }

    updateCustomDimensionHeight() {
        let tmpHeight;
        switch (this.shape.shape) {
            case 'triangle':
                tmpHeight = this.shape.h1;
                break;
            case 'circle':
                tmpHeight = this.shape.s1;
                this.shape.d = this.shape.s1;
                this.shape.s1 = this.shape.s1;
                break;
            case 'arc':
                tmpHeight = this.shape.h1 + this.shape.h2;
                break;
            case 'polygon':
                tmpHeight = Math.max(this.shape.h1, this.shape.h2, this.shape.h3);
                break;
            default:
                throw new Error('Value doesn\'t match');
        }

        return tmpHeight;
    }

    verifyEditableDimensions() {
        this.setCurrentMaxWidth();
        this.shapeError = false;
        this.widthError = false;
        this.heightError = false;

        if (this.mmWidth < this.attributes.minWidth) {
            this.mmWidth = this.attributes.minWidth;
            this.widthError = true;
        } else if (this.mmWidth > this.maxProductWidth) {
            this.mmWidth = this.maxProductWidth;
            this.widthError = true;
        }
        if (this.mmHeight < this.attributes.minHeight) {
            this.mmHeight = this.attributes.minHeight;
            this.heightError = true;
        } else if (this.mmHeight > this.attributes.maxHeight) {
            this.mmHeight = this.attributes.maxHeight;
            this.heightError = true;
        }
        if (this.bottom < 0) {
            this.bottom = 0;
            this.shapeError = true;
        } else if (this.bottom > this.mmHeight) {
            this.bottom = this.mmHeight;
            this.shapeError = true;
        }

        this.bottom = Math.floor(this.bottom);
        this.mmHeight = Math.floor(this.mmHeight);
        this.mmWidth = Math.floor(this.mmWidth);
    }

    verifyNonEditableDimensions() {
        const smallestWidthInDecimeter = parseInt(Object.keys(this.availableSizes)[0]);
        if (this.selectedWidth < smallestWidthInDecimeter) {
            this.selectedWidth = smallestWidthInDecimeter
        }
    }

    getEditableDimensionsObject() {
        if (this.mmHeight === 0) {
            this.mmHeight = this.height;
        }

        if (this.mmWidth === 0) {
            this.mmWidth = this.width;
        }

        if (this.oldDimensions.height === this.oldDimensions.bottom &&
            this.oldDimensions.bottom === this.bottom
        ) {
            this.bottom = this.mmHeight;
        }
        this.setCurrentMinAndMaxHeight();
        if (mmHeight > this.currentMaxHeight) {
            mmHeight = this.currentMaxHeight;
            this.heightError = true;
        } else if (mmHeight < this.currentMinHeight) {
            mmHeight = this.currentMinHeight;
            this.heightError = true;
        }

        const dimensions = {
            height: this.mmHeight,
            width: this.mmWidth,
            bottom: this.bottom
        };

        return dimensions;
    }

    getNonEditableDimensionsObject() {
        const dimensions = {};

        if (this.selectedUnit.type === 'fixed') {
            dimensions.height = this.selectedHeight;
            dimensions.width = this.selectedWidth;
        } else {
            dimensions.height = Math.round((this.selectedHeight - this.selectedUnit.montageSpace) * this.selectedUnit.multiplier);
            dimensions.width = Math.round((this.selectedWidth - this.selectedUnit.montageSpace) * this.selectedUnit.multiplier);
        }

        if (this.selectedBottomPanel) {
            if (this.selectedBottomPanel === 'Helglas') {
                dimensions.bottom = dimensions.height;
            } else {
                dimensions.bottom = Math.round((this.selectedBottomPanel - this.selectedUnit.montageSpace) * this.selectedUnit.multiplier);
            }
        } else {
            dimensions.bottom = null;
        }

        return dimensions;
    }

    addToCart(editing) {
        const availableAccessories = this.dataService.getAttributeOptions('accessory');

        if (availableAccessories.length > 0) {
            $('#modal-accessories-reminder').modal('show');
            if (!this.isMobile) {
                this.$rootScope.$emit('resetStep');
            }
        } else {
            this.apiService.addToCart(editing);
        }
        this.addToCartPinterestEvent();
        this.addToCartGTMEvent();
    }

    addToCartPinterestEvent() {
        window.pintrk('track', 'AddToCart', {
            value: this.dataService.price,
            order_quantity: this.dataService.quantity,
            currency: 'SEK'
        });
    }

    addToCartGTMEvent() {
        window.googleTagManagerService.pushAddToCartDataLayer(
            this.dataService.price,
            this.attributes.articleNumber,
            this.productInfo.configurationName,
            this.productInfo.productCategory,
            this.dataService.quantity,
        );
    }

    showMiniCartPreview() {
        window.scrollTo({
            top: 0
        });
        const cartPreview = angular.element('.cartPreviewDropdown');
        cartPreview.addClass('--active');
        setTimeout(function() {
            cartPreview.removeClass('--active');
        }, 4000);
    }

    unitsInit() {
        forEach(this.dataService.getAttributeOptions('unit'), (el1) => {
            const option = el1;
            option.attributes.id = el1.id;
            this.unit.push(el1.attributes);
        });
    }

    toggleDimensionInfo() {
        this.showDimensionInfo = !this.showDimensionInfo;
    }

    toggleCasementInfo() {
        this.showCasementInfo = !this.showCasementInfo;
    }

    openCasementModal() {
        this.showCasementInfo = true;
    }

    goToConfigurator() {
        this.$anchorScroll('configurator');
    }

    /*
     * we have max widht of every range, to find specific range we just can check
     * if current width is smaller than every range max width
     */
    setCurrentMinAndMaxHeight() {
        const milimeterSizes = this.attributes.availableSizesInMilimeters;
        const widthRanges = Object.keys(milimeterSizes);
        const widthRange = widthRanges.find(width => mmWidth <= width);
        this.currentMinHeight = milimeterSizes[widthRange].minHeight;
        this.currentMaxHeight = milimeterSizes[widthRange].maxHeight;

        const maxDimension = this.dataService.getMaxDimensionRules();
        if (maxDimension && this.currentMaxHeight > maxDimension.height) {
            this.currentMaxHeight = maxDimension.height;
        }
    }

    setCurrentMaxWidth() {
        const maxDimension = this.dataService.getMaxDimensionRules();
        if (maxDimension && this.attributes.maxWidth > maxDimension.width) {
            this.maxProductWidth = maxDimension.width;
        }
    }

    openBoxInConfigurator(type, defaultSelectedIdFieldName, modalTitle) {
        this.$rootScope.$emit('changeConfiguratorBoxEvent', type, defaultSelectedIdFieldName, modalTitle);
    }

    shouldAddToCartButtonBeBlocked(priceReloadCondition = true) {
        if (priceReloadCondition) {
            return !this.getTotalPrice() ||
                this.dataService.displayDimensionColorRuleNotice ||
                this.dataService.data.productInfo.hiddenPrice ||
                (this.dataService.isProductEligibleForGlazingRule() && this.glassRulesService.areConditionsMet(
                    this.dataService.getSelectedOption('insideGlass', 'glass'),
                    this.dataService.getSelectedOption('outsideGlass', 'glass')
                ));
        } else {
            return !this.getTotalPrice() ||
                this.dataService.priceReload ||
                this.dataService.displayDimensionColorRuleNotice ||
                this.dataService.data.productInfo.hiddenPrice ||
                (this.dataService.isProductEligibleForGlazingRule() && this.glassRulesService.areConditionsMet(
                    this.dataService.getSelectedOption('insideGlass', 'glass'),
                    this.dataService.getSelectedOption('outsideGlass', 'glass')
                ));
        }
    }
}

ConfiguratorHeaderCtrl.$inject = [
    'config',
    'dataService',
    'jsonService',
    '$cookies',
    '$scope',
    'apiService',
    '$locale',
    'windowDimensionsService',
    'handlesService',
    'cartBarsService',
    '$translate',
    '$anchorScroll',
    '$rootScope',
    'glassRulesService',
];

export default ConfiguratorHeaderCtrl;
